import { PayloadAction } from '@reduxjs/toolkit';
import { IRootState } from './type';

const reducers = {
  setStaff: (state: IRootState, action: PayloadAction<IRootState['staff']>) => ({
    ...state,
    staff: action.payload,
  }),
  setIsDisplaySuccessAnim: (state: IRootState, action: PayloadAction<IRootState['isDisplaySuccessAnimation']>) => ({
    ...state,
    isDisplaySuccessAnimation: action.payload,
  }),
};

export {
  reducers,
};
